/* Angela Rozas - traduccion al ingles de textos fijos del tema.
   Solo actua cuando el idioma activo de la tienda es ingles (html lang="en").
   Los textos traducibles desde el Admin (productos, colecciones, menus, etc.) ya vienen
   traducidos por Shopify; aqui solo se cubren los textos escritos directamente en el tema. */
(function () {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (lang.indexOf('en') !== 0) return;

  var D = {
    'Envío con seguimiento': 'Tracked shipping',
    'Entrega en 7-14 días laborables. Te enviamos el número de seguimiento en cuanto sale el pedido.': 'Delivery in 7–14 business days. We send you the tracking number as soon as your order ships.',
    'Pago seguro': 'Secure payment',
    'Compra de forma rápida y 100% segura.': 'Shop quickly and 100% securely.',
    'Devoluciones fáciles': 'Easy returns',
    'Tienes 30 días para cambios y devoluciones.': 'You have 30 days for exchanges and returns.',
    'Atención al cliente': 'Customer service',
    'Estamos aquí para ayudarte los 7 días de la semana.': 'We are here to help you 7 days a week.',
    'Tu email': 'Your email',
    'SUSCRIBIRME': 'SUBSCRIBE',
    'Gracias por suscribirte': 'Thank you for subscribing',
    'He leído y acepto la': 'I have read and accept the',
    'Envíos': 'Shipping',
    'Devoluciones': 'Returns',
    'Guía de tallas': 'Size guide',
    'Política de cookies': 'Cookie policy',
    'Gracias por contactarnos. Te responderemos lo antes posible.': 'Thank you for contacting us. We will get back to you as soon as possible.',
    'Correo electrónico': 'Email',
    'Número de teléfono': 'Phone number',
    'Nombre': 'Name',
    'Comentario': 'Message',
    'Enviar': 'Send',
    'Ver colección': 'View collection',
    'Próximamente': 'Coming soon',
    'Estamos preparando nuevas piezas para esta colección.': 'We are preparing new pieces for this collection.',
    'Siluetas que definen tu estilo.': 'Silhouettes that define your style.',
    'Detalles que transforman cada look.': 'Details that transform every look.',
    'El detalle final que completa tu estilo.': 'The finishing touch that completes your style.',
    'Capas esenciales para la nueva temporada.': 'Essential layers for the new season.',
    'Elegancia pensada para cada ocasión.': 'Elegance designed for every occasion.',
    'Los detalles que hacen la diferencia.': 'The details that make the difference.',
    'Descubre las últimas piezas de Angela Rozas.': 'Discover the latest pieces from Angela Rozas.',
    'Las piezas que nuestras clientas eligen una y otra vez.': 'The pieces our customers choose again and again.',
    'Descubre la selección de Angela Rozas.': 'Discover the Angela Rozas selection.',
    'Descripción': 'Description',
    'Cantidad': 'Quantity',
    'Talla': 'Size',
    'Añadir al carrito': 'Add to cart',
    'Agotado': 'Sold out',
    'No disponible': 'Unavailable',
    'Oferta': 'Sale',
    'Los': 'The',
    'gastos de envío': 'shipping costs',
    'se calculan en la pantalla de pago.': 'are calculated at checkout.',
    '¿Qué estás buscando?': 'What are you looking for?',
    'Búsquedas populares': 'Popular searches',
    'Mostrar más': 'Show more',
    'Disponibilidad': 'Availability',
    'Precio': 'Price',
    'En stock': 'In stock',
    'Destacados': 'Featured',
    'Más relevantes': 'Most relevant',
    'Más vendidos': 'Best selling',
    'Alfabéticamente, A-Z': 'Alphabetically, A-Z',
    'Alfabéticamente, Z-A': 'Alphabetically, Z-A',
    'Precio, de menor a mayor': 'Price, low to high',
    'Precio, de mayor a menor': 'Price, high to low',
    'Fecha, de más antigua a más reciente': 'Date, old to new',
    'Fecha, de más reciente a más antigua': 'Date, new to old',
    'Bienvenida': 'Welcome',
    'Un 10% de descuento en tu primera compra': '10% off your first order',
    'Suscríbete y te enviamos tu código al instante.': 'Subscribe and we will send you your code instantly.',
    'Suscribete y te enviamos tu codigo al instante.': 'Subscribe and we will send you your code instantly.',
    'Quiero mi 10%': 'I want my 10%',
    'No, gracias': 'No, thanks',
    '¡Ya casi está!': 'Almost there!',
    'Aquí tienes tu código': 'Here is your code',
    'Cópialo y pégalo en el carrito antes de pagar.': 'Copy it and paste it in your cart before checkout.',
    'Copiar': 'Copy',
    'Copiado': 'Copied',
    'Seguir comprando': 'Continue shopping',
    'Cerrar': 'Close',
    '1 unidad': '1 unit',
    '2 unidades': '2 units',
    'Precio estándar': 'Standard price',
    'Pack de 2 pares': 'Pack of 2 pairs',
    'Par 1': 'Pair 1',
    'Par 2': 'Pair 2',
    'Color': 'Color',
    'El descuento se aplica automáticamente en el carrito.': 'The discount is applied automatically in your cart.',
    'No se pudo añadir al carrito.': 'Could not add to cart.'
  };

  var R = [
    [/^Cantidad \((\d+) en el carrito\)$/, 'Quantity ($1 in cart)'],
    [/^\((\d+) en el carrito\)$/, '($1 in cart)'],
    [/^Reducir cantidad para (.+)$/, 'Decrease quantity for $1'],
    [/^Aumentar cantidad para (.+)$/, 'Increase quantity for $1'],
    [/^El precio más alto es (.+)$/, 'The highest price is $1'],
    [/^Añadir talla (.+) al carrito$/, 'Add size $1 to cart'],
    [/^Ver tallas disponibles$/, 'View available sizes'],
    [/^Ahorra (.+)$/i, 'Save $1'],
    [/^Elige la talla del par (\d)\.$/, 'Choose the size for pair $1.'],
    [/^El par (\d) no está disponible en esa combinación\. Prueba otra talla o color\.$/, 'Pair $1 is not available in that combination. Try another size or color.']
  ];

  function tr(s) {
    if (!s) return s;
    var t = s.replace(/\s+/g, ' ').trim();
    if (!t) return s;
    var out = null;
    if (Object.prototype.hasOwnProperty.call(D, t)) out = D[t];
    else {
      for (var i = 0; i < R.length; i++) {
        if (R[i][0].test(t)) { out = t.replace(R[i][0], R[i][1]); break; }
      }
    }
    if (out === null) return s;
    var lead = s.match(/^\s*/)[0];
    var trail = s.match(/\s*$/)[0];
    return lead + out + trail;
  }

  var ATTRS = ['placeholder', 'aria-label', 'title', 'alt', 'value'];

  function doText(node) {
    var v = node.nodeValue;
    var n = tr(v);
    if (n !== v) node.nodeValue = n;
  }

  function doEl(el) {
    if (el.nodeType !== 1) return;
    var tag = el.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return;
    for (var i = 0; i < ATTRS.length; i++) {
      var a = ATTRS[i];
      if (!el.hasAttribute(a)) continue;
      if (a === 'value' && !(tag === 'INPUT' && /^(submit|button)$/i.test(el.type))) continue;
      var old = el.getAttribute(a);
      var nv = tr(old);
      if (nv !== old) el.setAttribute(a, nv);
    }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { doText(root); return; }
    if (root.nodeType !== 1) return;
    doEl(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (n.nodeType === 3) {
        var p = n.parentNode;
        if (p && (p.tagName === 'SCRIPT' || p.tagName === 'STYLE' || p.tagName === 'NOSCRIPT')) continue;
        doText(n);
      } else doEl(n);
    }
  }

  function run() {
    walk(document.body);
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'characterData') doText(m.target);
        else if (m.type === 'attributes') doEl(m.target);
        else for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
      }
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }

  if (document.body) run();
  else document.addEventListener('DOMContentLoaded', run);
})();
